import axios from "axios";

const API_URL = process.env.REACT_APP_API_CORS;

export const FetchAxiosPost = async (url, data, token) => {
  const baseURL = API_URL + `${url}`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token}`,
    },
  };

  return await axios
    .post(baseURL, data, config)
    .then(response => {
      return response.data.insertedId;
    })
    .catch(error => {
      console.error("Error:", error);
      throw error;
    });
};

export const FetchAxiosPut = async (url, data, token) => {
  const baseURL = API_URL + `${url}`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token}`,
    },
  };

  await axios
    .put(baseURL, data, config)
    .then(response => {
    })
    .catch(error => {
      console.error("Error:", error);
    });
};

export const FetchAxiosGet = async (url, token, params = null) => {
  const baseURL = API_URL + `${url}`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token}`,
    },
    params,
  };

  return await axios
    .get(baseURL, config)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error("Error:", error);
      throw error;
    });
};

export const FetchAxiosFile = async (url, token, file) => {
  const baseURL = API_URL + `${url}`;
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  await axios
    .post(baseURL, formData, config)
    .then(response => {
    })
    .catch(error => {
      console.error("Error:", error);
    });
};

export const FetchAxiosDelte = async (url, token) => {
  const baseURL = API_URL + `${url}`;
  const config = {
    headers: {Authorization: `Bearer ${token}`}
  };

  return await axios
    .delete(baseURL, config)
    .catch(error => {
      console.error("Error:", error);
      throw error;
    });
};

